// src/admin/components/AdminMessages.js
import React from 'react';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import { useAdminStore } from '../state/adminStore';

const AdminMessages = () => {
  const { messages, removeMessage } = useAdminStore();

  if (messages.length === 0) return null;

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle className="h-5 w-5 text-green-400" />;
      case 'error':
        return <AlertCircle className="h-5 w-5 text-red-400" />;
      case 'warning':
        return <AlertTriangle className="h-5 w-5 text-yellow-400" />;
      default:
        return <Info className="h-5 w-5 text-blue-400" />;
    }
  };

  const getStyles = (type) => {
    switch (type) {
      case 'success':
        return 'bg-green-50 border-green-200 text-green-800';
      case 'error':
        return 'bg-red-50 border-red-200 text-red-800';
      case 'warning':
        return 'bg-yellow-50 border-yellow-200 text-yellow-800';
      default:
        return 'bg-blue-50 border-blue-200 text-blue-800';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2" style={{ maxWidth: '400px' }}>
      {messages.map((message) => (
        <div
          key={message.id}
          className={`p-4 rounded-lg shadow-lg border ${getStyles(message.type)} transition-all duration-300`}
        >
          <div className="flex items-start">
            <div className="flex-shrink-0">
              {getIcon(message.type)}
            </div>
            <div className="ml-3 flex-1">
              <p className="text-sm font-medium">{message.text}</p>
              <p className="text-xs opacity-75 mt-1">
                {message.timestamp?.toLocaleTimeString()}
              </p>
            </div>
            <div className="ml-3 flex-shrink-0">
              <button
                onClick={() => removeMessage(message.id)}
                className="inline-flex rounded-md p-1.5 hover:bg-black hover:bg-opacity-10 transition-colors"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminMessages;

